import { Info } from 'lucide-react';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';

interface Props { resources: string[]; }

/** #797 — informational (non-error) callout listing resources that wrote 0 rows
 *  across all targets on a successful run. Reads the structured
 *  `zero_row_resources` list, not a parsed message string. */
export function ZeroRowInfoPanel({ resources }: Props) {
  if (!resources.length) return null;
  return (
    <Alert variant="info" data-testid="zero-row-info-panel">
      <Info className="h-4 w-4" aria-hidden />
      <AlertTitle>Some resources produced no output</AlertTitle>
      <AlertDescription>
        <ul className="space-y-0.5">
          {resources.map((r) => (
            <li key={r} className="tabular-nums">
              <span className="font-semibold">{r}</span> — 0 rows, no output written
            </li>
          ))}
        </ul>
      </AlertDescription>
    </Alert>
  );
}
